<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="专题标题">
            <a-input v-model="searchForm.title" allowClear placeholder="请输入专题标题" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <v-range-picker v-model="times" @change="onChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增专题</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
        <a-button size="small" type="link" @click="lookArticle(record)">关联列表</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <Addspecial v-model="visible" :isEdit="isEdit" :params="waitItem" :platformList="platformList" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns, form } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import Addspecial from './components/Addspecial'
import compuedFun from './business/index'
import api from '@/api/'

export default {
  components: { Addspecial },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm }
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })

    const methods = {
      onChange(date, dateString) {
        state.searchForm.start_date = dateString[0]
        state.searchForm.end_date = dateString[1]
      },

      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        const res = await api.listSpecial({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { topic, pagination } = res.data
        _this.data = topic
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data.filter(item => {
          return item.parent_id === 0
        })
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 关联列表
      lookArticle(item) {
        _this.$router.push(`/relevancy/list/${item.id}?&title=${item.title}&org=${item.org}&line_id=${item.line_id}`)
      }
    }

    return {
      ...compuedFun(),
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>
